var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnuls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2346 0V9.01328C19.2331 10.6096 18.5983 12.14 17.4695 13.2688C16.3408 14.3976 14.8103 15.0324 13.214 15.0339V6.02656C13.214 4.42924 13.8481 2.89725 14.977 1.76722C16.106 0.637195 17.6373 0.00156447 19.2346 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0266 8.96021V17.9735C10.0266 19.5718 9.39162 21.1047 8.26142 22.2349C7.13122 23.3651 5.59834 24 4 24L4 14.9868C4 13.3884 4.63494 11.8555 5.76514 10.7253C6.89534 9.59514 8.42822 8.96021 10.0266 8.96021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnuls);
export default __webpack_public_path__ + "static/media/enuls.817bd5cdb06464fadfe63e28a37430e7.svg";
export { ForwardRef as ReactComponent };